import React, { HTMLAttributes } from 'react';
import Immutable from 'immutable';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import { Main } from '../../../components';
import useClasses from '../../../hooks/useClasses';
import { ImmutableGenericNodeEntity } from '..';
import LandingPageHero from './Hero';

import './style.scss';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableGenericNodeEntity;
}

const NodeLandingPage: React.FC<Props> = ({ entity, className }) => {
  const { buildClass, joinClasses } = useClasses('NodeLandingPage');

  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed'], '');
  const link: string = String(entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri'])));
  const linkTitle: string = String(entity.getIn(['field_link', 0, 'title'], ''));
  const svg = entity.getIn(['field_media_item', 0, 'entity', 'field_media_file', 0], Immutable.Map());
  const video = String(entity.getIn(['field_media_item', 0, 'embed'], ''));
  const paragraphs = entity.get('field_paragraphs', Immutable.List());

  return (
    <Main typeof="schema:WebPage" className={joinClasses(className, buildClass())}>
      <LandingPageHero
        title={title}
        body={body}
        linkTitle={linkTitle}
        link={link}
        video={video}
        svg={svg}
      />

      <Container>
        {paragraphs.size > 0 && (
          <div className={buildClass('paragraphs')}>
            {paragraphs.map((paragraph, index) => {
              const id = paragraph.get('target_id');
              const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
              return (
                <Paragraph
                  key={`paragraph:${id}:${language}`}
                  id={id}
                  entity={paragraph.get('entity')}
                  className="Paragraph"
                  index={index}
                />
              );
            })}
          </div>
        )}
      </Container>
    </Main>
  );
};

export default NodeLandingPage;
